import React, { Component } from 'react';
import { Stage, Layer, Rect, Text, Image, Transformer } from "react-konva";
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';


const CompleteButton = styled.button`
  background: #4ec1ea;
  color: white;
  border: none;
  width: 100%;
  text-align: center;
  font-weight: bold;
  letter-spacing: 1px;
  position: relative;
  // bottom: 0;
  z-index: 10;
  margin: 0 auto;
`
const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Nanum Gothic';
  div {
    width: 100%;
    height: 100%;
  }
  .konvajs-content {
    width: 100%;
    margin: 0 auto;
  }
  canvas {
    width: 100%;
  }
`

class Rectangle extends React.Component {
  render() {
    return (
      <Rect
        x={this.props.x}
        y={this.props.y}
        width={this.props.width}
        height={this.props.height}
        fill={this.props.fill}
        name={this.props.name}
        draggable
      />
    );
  }
}

class TextBox extends Component{
  render(){
    return(
      <Text
        x={this.props.x}
        y={this.props.y}
        
        fontSize={this.props.fontSize}
        fontFamily='Nanum Gothic'
        fill={this.props.fill}
        fontStyle={this.props.fontStyle}
        name={this.props.name}
        text={this.props.text}
        draggable
      />
    )
  }
}

class URLImage extends React.Component {
  state = {
    image: null
  };
  componentDidMount() {
    this.loadImage();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.src !== this.props.src) {
      this.loadImage();
    }
  }
  componentWillUnmount() {
    this.image.removeEventListener('load', this.handleLoad);
  }
  loadImage() {
    // save to "this" to remove "load" handler on unmount
    this.image = new window.Image();
    this.image.setAttribute('crossOrigin', 'anonymous');
    this.image.src = this.props.src;
    this.image.addEventListener('load', this.handleLoad);
  }
  handleLoad = () => {
    // after setState react-konva will update canvas and redraw the layer
    // because "image" property is changed
    this.setState({
      image: this.image
    });
    // if you keep same image object during source updates
    // you will have to update layer manually:
    // this.imageNode.getLayer().batchDraw();
  };
  render() {
    return (
      <Image
        x={this.props.x}
        y={this.props.y}
        image={this.state.image}
        width={this.props.width}
        height={this.props.height}
        name={this.props.name}
        ref={node => {
          this.imageNode = node;
        }}
        draggable
      />
    );
  }
}


class TransformerComponent extends React.Component {
  componentDidMount() {
    this.checkNode();
  }
  componentDidUpdate() {
    this.checkNode();
  }
  checkNode() {
    // here we need to manually attach or detach Transformer node
    const stage = this.transformer.getStage();
    const { selectedShapeName } = this.props;

    const selectedNode = stage.findOne('.' + selectedShapeName);
    let blank = ''
    
    try{
      console.log(selectedNode['_id']);
      blank = selectedNode['_id'];
    }
    catch (err) {
    }

    // do nothing if selected node is already attached
    if (selectedNode === this.transformer.node()) {
      return;
    }

    // do nothing if click outside of canvas
    if (blank === 21) {
      return;
    }

    if (selectedNode) {
      // attach to another node
      this.transformer.attachTo(selectedNode);
    } else {
      // remove transformer
      this.transformer.detach();
    }
    this.transformer.getLayer().batchDraw();
  }
  render() {
    return (
      <Transformer
        ref={node => {
          this.transformer = node;
        }}
      />
    );
  }
}


class Make extends Component {
  // constructor(props){
  //   super(props)
  // }
  state = {
    save: 0,
    image: null,
    info: {
      ...this.props.location.state
    },
    rectangles: this.props.location.state.template['rectangle'],
    texts: this.props.location.state.template['text'],
    images: this.props.location.state.template['image'],
    selectedShapeName: null
  };

  componentDidMount(){
    const canvasWrapper = document.getElementsByClassName('konvajs-content')[0];
    const canvas = document.getElementsByTagName('canvas')[0];
    // canvasWrapper.style.width = "100%";
    // canvasWrapper.style.height = "100%";
    // canvas.style.width = "100%";
    // canvas.style.height = "auto";
    // console.log(this.state);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    // save 값이 바뀌면 (hidden save onClick) 이미지 저장.
    if (prevState.save !== this.state.save) {
      /* 바로 complete 실행 시에는 selectedShapeName null이 반영되지 않아,
        setTimeout 사용함. */
      const complete = this.complete;
      const setCompleteImage = this.setCompleteImage;
      setTimeout(() => {
        // complete();
        setCompleteImage();
      }, 50)
    }
  }
  handleStageMouseDown = e => {
    // clicked on stage - cler selection
    if (e.target === e.target.getStage()) {
      this.setState({
        selectedShapeName: ''
      });
      return;
    }
    // clicked on transformer - do nothing
    const clickedOnTransformer =
      e.target.getParent().className === 'Transformer';
    if (clickedOnTransformer) {
      return;
    }

    // find clicked rect by its name
    const name = e.target.name();
    const rect = this.state.rectangles.find(r => r.name === name);
    // console.log(rect);
    const tex = this.state.texts.find(t => t.name === name);
    const img = this.state.images.find(i => i.name === name);

    if (rect || tex || img) {
      this.setState({
        selectedShapeName: name
      });
    } else {
      this.setState({
        selectedShapeName: ''
      });
    }
  };
  complete = () => {
    let image = '';
    var canvas = document.getElementsByTagName('canvas')[0];
    image = canvas.toDataURL("image/png", 1.0).replace("image/png", "image/octet-stream");
    window.location.href = image;
  }
  setCompleteImage = () => {
    let image = '';
    var canvas = document.getElementsByTagName('canvas')[0];
    image = canvas.toDataURL("image/png", 1.0).replace("image/png", "image/octet-stream");;
    this.setState({
      image: image
    });
  }
  changeSaveState = () => {
    const { save } = this.state;
    // 이미지 저장을 위해 save 값 바꿔주고, 선택된 개체 선택 해제해줌
    this.setState({
      ...this.state,
      save: save+1,
      selectedShapeName: null
    });
  }
  render() {
    const { image } = this.state;
    const { width, height } = this.state.info;
    const vw = window.innerWidth>=500 ? 500 : window.innerWidth;
    const ratio = vw/width;
    const nwidth = width/ratio;
    const nheight = height/ratio;
    
    return (
      <Container>
        {/* <link href="https://fonts.googleapis.com/css?family=Nanum+Gothic:400,700" rel="stylesheet"></link> */}
        {/* <img className="placeholder"/> */}
        <Stage
          width={width}
          height={height}
          onMouseDown={this.handleStageMouseDown}
          onTap={this.handleStageMouseDown}
        >
          <Layer>
            {this.state.rectangles.map((rect, i) => (
              <Rectangle key={i} {...rect} />
            ))}
            {this.state.images.map((img, i) => (
              <URLImage key={i}
                {...img}
                src={this.state.info[img.name]}
              />
            ))}
            {this.state.texts.map((text, i) => (
              <TextBox key={i} {...text} text={this.state.info[text.name]}/>
            ))}
            <TransformerComponent
              selectedShapeName={this.state.selectedShapeName}
            />
          </Layer>
        </Stage>
        { vw>=500 
        ? <CompleteButton onClick={this.changeSaveState}>save</CompleteButton>
        : <CompleteButton onClick={this.changeSaveState}>Complete</CompleteButton> }
        
        
        {image && 
          <Redirect
          to={{
            pathname: "/complete",
            state: { image: image }
          }}
        />}
      </Container>
    );
  }
}

export default Make;